import React from 'react';
import { createRoot } from 'react-dom/client';
import "../errorHandling";

import Login from '@components/Login';

const loadLogin = () => {
  const container = document.getElementById('login-component');

  if (container) {
    const data = JSON.parse(container.dataset.props);
    const root = createRoot(container);

    root.render(<Login data={data} />);
  }
}


document.addEventListener('DOMContentLoaded', () => {
  loadLogin();
})
